import React from "react";
import FreefieldProfileList from "./FreefieldProfileList";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";

interface Props {
  selectedFreefieldProfiles: server.dto.FreeFieldProfileSmall[]
  onChange: (newFreefieldProfiles: server.dto.FreeFieldProfileSmall[]) => void
  environment: server.dto.Environments;
}

const FreefieldProfileMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedFreefieldProfiles}
    onRemove={props.onChange}
    getId={freefieldProfile => freefieldProfile.freeFieldProfileId}
    getLabel={freefieldProfile => <div>
      {freefieldProfile.title}
    </div>}
  >
    <FreefieldProfileList
      onItemSelected={(item) => props.onChange([...props.selectedFreefieldProfiles, item])}
      excludeKeys={props.selectedFreefieldProfiles.map(ff => ff.freeFieldProfileId)}
      environment={props.environment}
    />
  </MultiPickerSelectedItems>;
};

export default FreefieldProfileMultiPicker;